import { render, staticRenderFns } from "./tableau.vue?vue&type=template&id=280b591b&"
import script from "./tableau.vue?vue&type=script&lang=js&"
export * from "./tableau.vue?vue&type=script&lang=js&"
import style0 from "./tableau.vue?vue&type=style&index=0&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280b591b')) {
      api.createRecord('280b591b', component.options)
    } else {
      api.reload('280b591b', component.options)
    }
    module.hot.accept("./tableau.vue?vue&type=template&id=280b591b&", function () {
      api.rerender('280b591b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/provisions/tableau.vue"
export default component.exports